// extracted by mini-css-extract-plugin
export default {"container":"register_container__dzP3t","logoContainer":"register_logoContainer__A7V58"};